export const Button = ({title, onClickCallback}: { title: string, onClickCallback?: () => void }) => {
  return (
    <button onClick={() => onClickCallback && onClickCallback()}>
      {title}
    </button>
  )
}
